import React, { useEffect, useState } from 'react';
import './ModalComponent.css'
import RegisterServices from '../../services/RegisterServices';
import Swal from 'sweetalert2';
import AuthServices from '../../services/AuthServices';
import { useNavigate } from 'react-router-dom';
import logsUserService from '../../services/UserLogServices';
import { Button, Card, Radio, Label } from 'flowbite-react';
import QuestionServices from '../../services/QuestionServices';
import RegisterAnswerServices from '../../services/RegisterAnswerServices';


const ModalComponent = ({ showModal, closeModal }) => {
    const [formData, setFormData] = useState({
        name: '',
        last_name: '',
        email: '',
        specialty: '',
        dni: '',
        phone: '',
        country: '',
        city: '',
        urlCampaign: window.location.href
    });
    const [email, setEmail] = useState('');
    const [showRegister, setShowRegister] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleLogin = (e) => {
        setEmail(e.target.value);
    };

    const changeModal = () => {
        setShowRegister(!showRegister);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const newErrors = {};

        // Validating email
        if (!formData.email || !emailRegex.test(formData.email)) {
            newErrors.email = 'Por favor, ingrese una dirección de correo electrónico válida.';
        }

        if (Object.keys(newErrors).length === 0) {
            try {
                await RegisterServices(formData);

                Swal.fire({
                    title: '¡Registro exitoso!',
                    icon: "success",
                    text: 'Su registro ha sido completado con éxito. esperamos verlo el día 05 de octubre',
                    confirmButtonText: 'Cerrar',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                    },
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        closeModal();
                        window.location.reload();
                    }
                });
                setFormData({
                    name: '',
                    last_name: '',
                    email: '',
                    specialty: '',
                    dni: '',
                    phone: '',
                    country: '',
                    city: ''
                });
            } catch (err) {
                Swal.fire({
                    title: '¡Usuario Existente!',
                    icon: "error",
                    text: 'El registro ya existe. Por favor, verifica los datos e intenta nuevamente.',
                    confirmButtonText: 'Cerrar',
                    customClass: {
                        confirmButton: 'btn btn-danger',
                    },
                });
            }
        }
    };

    const submitLogin = async () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!email || !emailRegex.test(email)) {
            Swal.fire({
                title: 'Error',
                icon: 'error',
                text: 'Por favor, ingrese una dirección de correo electrónico válida.',
                confirmButtonText: 'Cerrar',
                customClass: {
                    confirmButton: 'btn btn-danger',
                },
            });
            return;
        }

        try {
            const response = await AuthServices(email);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Sesión exitosa, cargando...',
                customClass: {
                    title: "text-center"
                },
                showConfirmButton: false, // Mostrar el botón de confirmación
                timer: 2500,
                timerProgressBar: true,
                willClose: () => {
                    closeModal();
                    const userData = {
                        user: response['id_user'],
                        action: 'login pauta',
                        urlCampaign: window.location.href
                    }

                    logsUserService(userData.user, userData.action, userData.urlCampaign);

                    sessionStorage.setItem('token', response['access']);
                    sessionStorage.setItem('username', response['name']);
                    sessionStorage.setItem('country', response['country']);
                    sessionStorage.setItem('city', response['city']);
                    sessionStorage.setItem('email', response['email']);
                    sessionStorage.setItem('lastName', response['last_name']);
                    sessionStorage.setItem('id_user', response['id_user']);
                    sessionStorage.setItem('id_event', response['eventInscribed'])

                    // Obtener parámetros de la URL
                    const urlParams = new URLSearchParams(window.location.search);
                    const utmSource = urlParams.get('utm_source');
                    const chatLive = urlParams.get('chat');

                    // Redirige a /chatLive si chat es "yes"
                    if (chatLive === 'yes') {
                        navigate('/chatLive');
                        sessionStorage.setItem('is_chat', true);
                    } else if (utmSource === 'qr-code') {
                        // Si el parámetro utm_source es 'qr-code'
                        navigate('/certificados');
                        sessionStorage.setItem('is_qr', true);
                    } else {
                        // Si no se cumplen las condiciones anteriores, redirigir a /inicio
                        navigate('/inicio');
                    }
                }
            });
        } catch (error) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: error,
                customClass: {
                    title: "text-center"
                },
                showConfirmButton: false, // Mostrar el botón de confirmación
                timer: 2500,
                timerProgressBar: true,
            });

            window.href = 'https://scienncetvnovonordisk.com/medico-innovador'
        }
    };

    return (
        <>
            {/* login */}
            <div className={`fixed inset-0 z-50 h-full flex items-center justify-center bg-black bg-opacity-50 overflow-y-scroll ${showModal ? 'flex' : 'hidden'} ${!showRegister ? 'flex' : 'hidden'}`}>
                <div className="relative p-4 sm:p-0 w-full max-w-2xl max-h-screen" style={{ scale: '0.85' }}>
                    <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                        <div className="flex flex-col p-4 md:p-5 rounded-t dark:border-gray-600">
                            <button
                                type="button"
                                className="text-white fw-bold bg-aqua-light hover:text-gray-900 rounded-full text-sm w-8 h-8 flex items-center justify-center ms-auto mb-1 self-end dark:hover:bg-gray-600 dark:hover:text-white"
                                onClick={closeModal}
                            >
                                <svg
                                    className="w-4 h-4"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 14 14"
                                >
                                    <path
                                        stroke="currentColor"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                    />
                                </svg>
                                <span className="sr-only">Close modal</span>
                            </button>

                            <h3 className="text-3xl text-dark-blue text-center font-semibold text-gray-900 dark:text-white mb-4">
                                Bienvenido/a
                            </h3>
                            <form>
                                {/* Correo electrónico */}
                                <div className="col-span-1">
                                    <label
                                        htmlFor="email"
                                        className="md:mx-5 lg:mx-5 xl:mx-5 mb-2 block text-dark-blue fw-bold fs-5 text-sm font-semibold mb-1 text-start dark:text-white"
                                    >
                                        Email*
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block mx-auto w-full max-w-md p-2.5 text-left dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                        placeholder="Ingrese su correo electrónico"
                                        value={email}
                                        onChange={handleLogin}
                                        required
                                    />
                                </div>

                                <button
                                    type="button"
                                    className="bg-aqua-light p-2 rounded-full text-white fw-bold w-full sm:w-80 mt-4 mx-auto block"
                                    onClick={submitLogin}
                                >
                                    Iniciar sesión
                                </button>

                                <div className="flex items-center justify-center mt-4">
                                    <input
                                        id="remember-me"
                                        type="checkbox"
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                                    />
                                    <label
                                        htmlFor="remember-me"
                                        className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                    >
                                        Recordar usuario
                                    </label>
                                </div>
                            </form>
                        </div>

                        <footer className="bg-gradient-to-r from-[#61dafb] to-[#00166f] text-white py-4">
                            <div className="container mx-auto flex flex-col items-center text-center">
                                <div className="mb-3 fw-bold fs-5">
                                    ¿Aún no tiene una cuenta?
                                </div>
                                <div className="col-span-2 flex justify-center align-content-center">
                                    <button
                                        className="bg-aqua-light p-2 rounded-full text-white fw-bold fs-5 w-full"
                                        onClick={changeModal}
                                    >
                                        Regístrese aquí
                                    </button>
                                </div>
                            </div>
                        </footer>
                    </div>
                </div>
            </div>

            {/* register */}
            <div className={`fixed inset-0 z-50  h-full flex items-center justify-center bg-black bg-opacity-50 overflow-y-scroll mb-5 ${showModal ? 'flex' : 'hidden'} ${showRegister ? 'flex' : 'hidden'}`}>
                <div className="relative p-4 sm:p-0 w-full max-w-2xl max-h-screen" style={{ scale: '0.85' }}>
                    <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                        <div className="flex flex-col p-4 md:p-5 rounded-t dark:border-gray-600">
                            <button
                                type="button"
                                className="text-white fw-bold bg-aqua-light hover:text-gray-900 rounded-full text-sm w-8 h-8 flex items-center justify-center ms-auto mb-1 self-end dark:hover:bg-gray-600 dark:hover:text-white"
                                onClick={closeModal}
                            >
                                <svg
                                    className="w-4 h-4"  // Ajusta el tamaño del ícono aquí
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 14 14"
                                >
                                    <path
                                        stroke="currentColor"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                    />
                                </svg>
                                <span className="sr-only">Close modal</span>
                            </button>

                            <h3 className="text-2xl text-dark-blue text-center font-semibold text-gray-900 dark:text-white mb-0">
                                Regístrese en el Curso de Actualización <br />
                                en diabetes para Médico iNNovador 2024
                            </h3>
                            <p className="text-center text-gray-600 dark:text-gray-300 mb-4 text-dark-blue">
                                ¿Ya tienes una cuenta?{' '}
                                <button
                                    type="button"
                                    className="text-blue-500 hover:underline"
                                    onClick={changeModal}
                                >
                                    Inicia sesión
                                </button>
                            </p>
                        </div>
                        <div className="p-6 md:p-8">
                            <form className="hidden md:grid lg:grid xl:grid grid-cols-1 sm:grid-cols-2 gap-4" onSubmit={handleSubmit}>
                                {/* Nombre */}
                                <div className="col-span-1">
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Nombre"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                        value={formData.name.toLowerCase()}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                {/* Apellido */}
                                <div className="col-span-1">
                                    <input
                                        type="text"
                                        id="last-name"
                                        name="last_name"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                        placeholder="Apellido"
                                        value={formData.last_name.toLowerCase()}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                {/* Correo electrónico */}
                                <div className="col-span-1">
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                        placeholder="example@gmail.com"
                                        value={formData.email.toLowerCase()}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                {/* Especialidad */}
                                <div className="col-span-1">
                                    <select
                                        id="specialty"
                                        name="specialty"
                                        value={formData.specialty}
                                        onChange={handleChange}
                                        required
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                    >
                                        <option value="">Selecciona una opción</option>
                                        <option value="Diabetología">Diabetología</option>
                                        <option value="Cardiología">Cardiología</option>
                                        <option value="Administración">Administración</option>
                                        <option value="Medicina general">Medicina general</option>
                                        <option value="Medicina familiar">Medicina familiar</option>
                                        <option value="Neurología">Neurología</option>
                                        <option value="Nefrología">Nefrología</option>
                                        <option value="Endocrinología">Endocrinología</option>
                                        <option value="Médico internista">Médico internista</option>
                                        <option value="Otro">Otro</option>
                                    </select>
                                </div>

                                {/* Documento */}
                                <div className="col-span-1">
                                    <input
                                        type="number"
                                        id="document"
                                        name="dni"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                        placeholder="Documento"
                                        value={formData.dni}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                {/* Número telefónico */}
                                <div className="col-span-1">
                                    <input
                                        type="number"
                                        id="phone"
                                        name="phone"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                        placeholder="Número telefónico"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                {/* País */}
                                <div className="col-span-1">
                                    <select
                                        name="country"
                                        id="country"
                                        value={formData.country}
                                        onChange={handleChange}
                                        required
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                    >
                                        <option value="">Selecciona una opción</option>
                                        <option value="Panamá">Panamá</option>
                                        <option value="Aruba">Aruba</option>
                                        <option value="Costa Rica">Costa Rica</option>
                                        <option value="Curazao">Curazao</option>
                                        <option value="Ecuador">Ecuador</option>
                                        <option value="Guatemala">Guatemala</option>
                                        <option value="Honduras">Honduras</option>
                                        <option value="Nicaragua">Nicaragua</option>
                                        <option value="Paraguay">Paraguay</option>
                                        <option value="Perú">Perú</option>
                                        <option value="República Dominicana">República Dominicana</option>
                                        <option value="Uruguay">Uruguay</option>
                                        <option value="Otro">Otro</option>
                                    </select>
                                </div>

                                {/* Ciudad */}
                                <div className="col-span-1">
                                    <input
                                        type="text"
                                        id="city"
                                        name="city"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                        placeholder="Ciudad"
                                        value={formData.city.toLowerCase()}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-span-2">
                                    {/* Aceptar términos y condiciones */}
                                    <div className="flex items-center justify-center mb-3">
                                        <input
                                            id="terms"
                                            type="checkbox"
                                            value=""
                                            className="w-4 h-4 border border-gray-300 rounded-full bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-600 dark:border-gray-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800"
                                            required
                                        />
                                        <label
                                            htmlFor="terms"
                                            className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                        >
                                            Aceptar términos y condiciones*
                                        </label>
                                    </div>

                                    <p className="m-0 p-0 mt-3 mb-3 text-start container-text-legals">
                                        "La Compañía procesa los datos suministrados para transmitir
                                        información relevante relacionada a eventos, contenido científico
                                        y recursos de educación médica continua"
                                    </p>
                                </div>
                                {/* Botón de registrar */}
                                <div className="col-span-2 flex justify-center align-content-center">
                                    <button
                                        type="submit"
                                        className="bg-aqua-light p-2 rounded-full text-white fw-bold fs-5 w-96"
                                    >
                                        Regístrar
                                    </button>
                                </div>
                            </form>

                            <form className="grid md:hidden lg:hidden xl:hidden grid-cols-1 gap-4" onSubmit={handleSubmit}>
                                {/* Nombre */}
                                <div>
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Nombre"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                {/* Apellido */}
                                <div>
                                    <input
                                        type="text"
                                        id="last-name"
                                        name="last_name"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                        placeholder="Apellido"
                                        value={formData.last_name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                {/* Correo electrónico */}
                                <div>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                        placeholder="example@gmail.com"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                {/* Especialidad */}
                                <div>
                                    <select
                                        id="specialty"
                                        name="specialty"
                                        value={formData.specialty}
                                        onChange={handleChange}
                                        required
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                    >
                                        <option value="">Selecciona una opción</option>
                                        <option value="Diabetología">Diabetología</option>
                                        <option value="Cardiología">Cardiología</option>
                                        <option value="Administración">Administración</option>
                                        <option value="Medicina general">Medicina general</option>
                                        <option value="Medicina familiar">Medicina familiar</option>
                                        <option value="Neurología">Neurología</option>
                                        <option value="Nefrología">Nefrología</option>
                                        <option value="Endocrinología">Endocrinología</option>
                                        <option value="Médico internista">Médico internista</option>
                                        <option value="Otro">Otro</option>
                                    </select>
                                </div>

                                {/* Documento */}
                                <div>
                                    <input
                                        type="text"
                                        id="document"
                                        name="dni"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                        placeholder="Documento"
                                        value={formData.dni}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                {/* Número telefónico */}
                                <div>
                                    <input
                                        type="tel"
                                        id="phone"
                                        name="phone"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                        placeholder="Número telefónico"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                {/* País */}
                                <div>
                                    <select
                                        name="country"
                                        id="country"
                                        value={formData.country}
                                        onChange={handleChange}
                                        required
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                    >
                                        <option value="">Selecciona una opción</option>
                                        <option value="Panamá">Panamá</option>
                                        <option value="Aruba">Aruba</option>
                                        <option value="Costa Rica">Costa Rica</option>
                                        <option value="Curazao">Curazao</option>
                                        <option value="Ecuador">Ecuador</option>
                                        <option value="Guatemala">Guatemala</option>
                                        <option value="Honduras">Honduras</option>
                                        <option value="Nicaragua">Nicaragua</option>
                                        <option value="Paraguay">Paraguay</option>
                                        <option value="Perú">Perú</option>
                                        <option value="República Dominicana">República Dominicana</option>
                                        <option value="Uruguay">Uruguay</option>
                                        <option value="Otro">Otro</option>
                                    </select>
                                </div>

                                {/* Ciudad */}
                                <div>
                                    <input
                                        type="text"
                                        id="city"
                                        name="city"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                        placeholder="Ciudad"
                                        value={formData.city}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div>
                                    {/* Aceptar términos y condiciones */}
                                    <div className="flex items-center justify-center mb-3">
                                        <input
                                            id="terms"
                                            type="checkbox"
                                            value=""
                                            className="w-4 h-4 border border-gray-300 rounded-full bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-600 dark:border-gray-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800"
                                            required
                                        />
                                        <label
                                            htmlFor="terms"
                                            className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                                        >
                                            Aceptar términos y condiciones*
                                        </label>
                                    </div>

                                    <p className="m-0 p-0 mt-3 mb-3 text-start container-text-legals">
                                        "La Compañía procesa los datos suministrados para transmitir
                                        información relevante relacionada a eventos, contenido científico
                                        y recursos de educación médica continua"
                                    </p>
                                </div>
                                {/* Botón de registrar */}
                                <div className="flex justify-center align-content-center">
                                    <button
                                        type="submit"
                                        className="bg-aqua-light p-2 rounded-full text-white fw-bold fs-5 w-96"
                                    >
                                        Regístrar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export const ModalDoctors = ({ showModal, closeModal, pictureDoctor, flagDoctor, nameDoctor, profession, description }) => {
    const formatDescription = (description) => {
        return description?.split(',').map((line, index) => (
            <p key={index} className="mb-2">{line}</p>
        ));
    };

    return (
        <div class={`fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50 ${showModal ? 'flex' : 'hidden'}`}>
            <div class="hidden md:flex lg:flex xl:flex rounded-[20px] max-w-2xl flex flex-col items-center bg-white border border-gray-200 rounded-lg shadow md:flex-row md:max-w-2xl hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700 relative">
                <img class="object-cover w-full rounded-t-lg h-100 md:h-auto md:w-60" src={pictureDoctor} alt="" />
                <img src={flagDoctor} className="w-14 h-14 mt-4 ml-2 absolute top-26 left-60 transform -translate-x-2/4 -translate-y-1/4" alt="flag" />
                <div class="flex flex-col justify-between p-4 leading-normal w-full mx-4">
                    <button class="absolute top-2 right-2 text-gray-600 hover:text-gray-800 text-white fw-bold bg-aqua-light rounded-full" onClick={closeModal}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                    <h5 class="mb-0 text-2xl font-bold text-[#00166F] dark:text-white text-center">{nameDoctor}</h5>
                    <p className='font-bold text-gray-700 text-center'>{profession}</p>
                    <p class="mb-3 font-normal text-gray-700 dark:text-gray-400 text-xs text-justify">{formatDescription(description)}</p>
                </div>
            </div>

            <div class="block md:hidden lg:hidden xl:hidden max-w-sm bg-white border border-gray-200 rounded-[20px] shadow dark:bg-gray-800 dark:border-gray-700 relative" style={{ scale: '0.75' }}>
                <button class="absolute top-2 right-2 text-gray-600 hover:text-gray-800 text-white font-bold bg-aqua-light rounded-full" onClick={closeModal}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-10 h-10">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                <img class="object-cover w-full rounded-[20px] h-96 md:h-auto md:w-26" src={pictureDoctor} alt="doctor" />
                <img src={flagDoctor} className="w-[120px] h-18 mt-0 ml-2 absolute inset-x-1/2 transform -translate-x-1/2 -translate-y-1/2" alt="flag" />
                <div class="p-5 mt-10">
                    <h5 class="mb-0 text-2xl font-bold text-[#00166F] dark:text-white text-center">{nameDoctor}</h5>
                    <p className='font-bold text-gray-700 text-center'>{profession}</p>
                    <p class="mb-3 font-normal text-gray-700 dark:text-gray-400 text-xs text-justify">{formatDescription(description)}</p>
                </div>
            </div>
        </div>
    )

}

export const ModalQuestions = ({ showModal, closeModal }) => {
    const [questionsData, setQuestionData] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [selectedAnswers, setSelectedAnswers] = useState(Array(questionsData.length).fill(''));

    const token = sessionStorage.getItem('token');
    const event_id = sessionStorage.getItem('id_event');
    const idUser = sessionStorage.getItem('id_user');

    useEffect(() => {
        if (showModal) {
            setSelectedAnswers([])
            const getQuestions = async () => {
                const response = await QuestionServices(token, event_id);

                console.log(response);
                setQuestionData(response);
            };

            getQuestions();
        }
    }, [showModal, token, event_id]);

    const handleRadioChange = (event) => {
        const newAnswers = [...selectedAnswers];
        newAnswers[currentQuestion] = event.target.value;
        setSelectedAnswers(newAnswers);
    };

    const handleNext = () => {
        if (currentQuestion < questionsData.length - 1) {
            setCurrentQuestion(currentQuestion + 1);
        }
    };

    const handlePrevious = () => {
        if (currentQuestion > 0) {
            setCurrentQuestion(currentQuestion - 1);
        }
    };

    const saveAnswers = async (dataArray) => {
        try {
            const answersToSave = selectedAnswers.map((selectedOption, index) => {
                const correctOption = dataArray[index].opciones.find(option => option.is_correct);

                // Convert the selected option (like 'A', 'B', 'C', ...) to a numeric index (0, 1, 2, ...)
                const selectedIndex = selectedOption.charCodeAt(0) - 65; // 'A' is 65 in ASCII

                // Get the selected option using the calculated index
                const selectedAnswerOption = dataArray[index].opciones[selectedIndex];

                return {
                    user_id: Number(sessionStorage.getItem('id_user')),
                    question_id: dataArray[index].id,
                    selected_option_id: selectedAnswerOption ? selectedAnswerOption.id : null, // Use selected option ID
                    correct_option_id: correctOption ? correctOption.id : null, // Use correct option ID
                };
            });

            console.log("Respuestas a guardar:", answersToSave);

            // Here you can add your logic to send `answersToSave` to your server or database

            answersToSave.forEach(async (element) => {
                const data = {
                    'user_id': element.user_id,
                    'question_id': element.question_id,
                    'selected_option': element.selected_option_id,
                    'correct_option': element.correct_option_id,
                }


                await RegisterAnswerServices(token, data);
            });



        } catch (error) {
            throw new Error(error);
        }
    };

    return (
        <>
            {/* login */}
            <div className={`fixed inset-0 z-50 h-full flex items-center justify-center bg-black bg-opacity-50 overflow-y-scroll ${showModal ? 'flex' : 'hidden'}`}>
                <div className="relative p-4 sm:p-0 w-full max-w-2xl max-h-screen" style={{ scale: '0.85' }}>
                    <Card className="w-full max-w-2xl">
                        <button
                            type="button"
                            className="text-white fw-bold bg-aqua-light hover:text-gray-900 rounded-full text-sm w-8 h-8 flex items-center justify-center ms-auto mb-1 self-end dark:hover:bg-gray-600 dark:hover:text-white"
                            onClick={() => {
                                logsUserService(idUser, 'Close PopUp Preguntas', window.location.href)
                                closeModal();
                            }}
                        >
                            <svg
                                className="w-4 h-4"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 14 14"
                            >
                                <path
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                />
                            </svg>
                            <span className="sr-only">Close modal</span>
                        </button>
                        <div className="flex mb-4">
                            {questionsData?.map((_, index) => (
                                <div
                                    key={index}
                                    className={`flex-1 h-2 ${index < currentQuestion
                                        ? 'bg-blue-500'
                                        : index === currentQuestion
                                            ? 'bg-blue-300'
                                            : 'bg-gray-200'
                                        } ${index === 0 ? 'rounded-l-full' : ''} ${index === questionsData.length - 1 ? 'rounded-r-full' : ''}`}
                                />
                            ))}
                        </div>
                        <div className="flex items-center mb-4">
                            <div className="bg-blue-500 text-white rounded-full p-2 mr-2">
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <h2 className="text-xl font-bold text-blue-500">Responda la pregunta</h2>
                        </div>
                        <h3 className="text-lg font-semibold mb-4 text-center">
                            {questionsData[currentQuestion]?.question_text}
                        </h3>
                        <p className="text-sm text-gray-500 mb-4 text-center">Seleccione la respuesta correcta:</p>
                        <form className="flex flex-col gap-4">
                            <div className="flex flex-col">
                                {questionsData[currentQuestion]?.opciones?.map((option, index) => {
                                    const isSelected = selectedAnswers[currentQuestion] === String.fromCharCode(65 + index);
                                    const isCorrect = option.is_correct;
                                    const hasAnswered = selectedAnswers[currentQuestion] !== undefined;

                                    let backgroundClass = '';

                                    if (hasAnswered) {
                                        if (isCorrect && isSelected) {
                                            backgroundClass = 'bg-green-200';
                                        } else if (!isCorrect && isSelected) {
                                            backgroundClass = 'bg-red-200';
                                        } else if (isCorrect) {
                                            backgroundClass = 'bg-green-100';
                                        } else {
                                            backgroundClass = 'bg-red-100';
                                        }
                                    }

                                    return (
                                        <div
                                            key={index}
                                            className={`flex items-center gap-2 p-2 mb-2 rounded ${backgroundClass}`}
                                        >
                                            <Radio
                                                id={`answer-${index}`}
                                                name="answers"
                                                value={String.fromCharCode(65 + index)}
                                                onChange={handleRadioChange}
                                                checked={isSelected}
                                                disabled={hasAnswered}
                                            />
                                            <Label htmlFor={`answer-${index}`}>
                                                ({String.fromCharCode(65 + index)}). {option.option_text}
                                            </Label>
                                        </div>
                                    );
                                })}
                            </div>
                        </form>
                        <div className="flex justify-between mt-4">
                            <Button color="gray" onClick={handlePrevious} disabled={currentQuestion === 0}>
                                Anterior
                            </Button>

                            {/* Muestra el botón "Siguiente" solo si no es la última pregunta */}
                            {currentQuestion < questionsData.length - 1 && (
                                <Button
                                    color="blue"
                                    onClick={handleNext}
                                    disabled={currentQuestion === questionsData.length - 1 || !selectedAnswers[currentQuestion]}
                                >
                                    Siguiente
                                </Button>
                            )}

                            {currentQuestion === questionsData.length - 1 && (
                                <Button
                                    color="success"
                                    onClick={() => {
                                        saveAnswers(questionsData); // Envía las preguntas al guardar respuestas
                                        closeModal();
                                        setSelectedAnswers([]);
                                    }}
                                    disabled={!selectedAnswers[currentQuestion]}
                                >
                                    Finalizar
                                </Button>
                            )}
                        </div>
                    </Card>
                </div>
            </div>
        </>
    );
};


export default ModalComponent;
